import { Button } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import {
    buildFreeMessage,
    buildListCategoriesMessage,
    buildQAFormLiveChat,
    buildQAFormMessage,
    checkMessageOutOfSession,
    postMessage
} from './handler/ChatBoxHandler';
import { memo, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { updatePreviewSettingAtom } from '@/state/atom/chatBotPreview';
import Constant from '@/common/constant/Constant';
import { v4 as uuidv4 } from 'uuid';

function MessageEndLiveChat({
    message,
    chatbotSetting,
    isModePreview,
}) {
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessage, setFreeMessage] = useState('');
    const [messageState, setMessagesState] = useState(message);
    useEffect(() => {
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message);
        }
    }, [message]);
    useEffect(() => {
        if (!isModePreview) {
            setFreeMessage(chatbotSetting.freeMsg);
        }
    }, [chatbotSetting]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.freeMsg !== freeMessage) {
                setFreeMessage(previewSetting.freeMsg);
            }
        }
    }, [previewSetting]);

    return (
        <span className="line-endchat">
            <h2><span>{message.content}</span></h2>
        </span>
    );
}

export default memo(MessageEndLiveChat);
